import React from 'react';
import Page from "../../../components/pages/grid/Page/Page";

const PageGridPage = () => {
    return <Page />
};

export default PageGridPage;